import { render } from "./i-select.vue?vue&type=template&id=bd85d606&scoped=true"
import script from "./i-select.vue?vue&type=script&lang=js"
export * from "./i-select.vue?vue&type=script&lang=js"

import "./i-select.vue?vue&type=style&index=0&id=bd85d606&scoped=true&lang=css"
import "./i-select.vue?vue&type=style&index=1&id=bd85d606&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd85d606"]])

export default __exports__